import gql from "graphql-tag";

export default gql`mutation CreateUploadFiles($id:Int!, $uploadids:[Int]!) {
    createUploadFiles(id:$id, uploadids:$uploadids) 
  }`